<template>
  <div>
    <!-- 退换货办理 -->
    <div class="rj-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: 'returnExchangeChief' }">
          合同列表
        </el-breadcrumb-item>
        <el-breadcrumb-item>退货合同</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <baseInfo :info="info" />
    <contractAttachmentList :contract-attachment-list-data="contractAttachmentListData" />
    <history ref="history" :history-data="historyData" />
    <product :product-data="productData" />
    <span v-if="!$route.query.isCheck">
      <el-button type="primary" @click="submit">提交</el-button>
      <el-button @click="back">驳回到代理商</el-button>
    </span>

    <el-dialog title="驳回意见" :visible.sync="rejectedVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="500" lock-scroll>
      <div>
        <el-input
          v-model="rejectedInfo"
          type="textarea"
          placeholder="请输入您的驳回意见"
          maxlength="200"
          show-word-limit
          rows="6"
        />
      </div>
      <div class="block" style="text-align: right;padding-top: 20px">
        <el-button @click="initReject">
          取 消
        </el-button>
        <el-button type="primary" @click="submitReject">
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import baseInfo from './baseInfo';
import history from './history.vue';
import product from './product.vue';
import contractAttachmentList from './contractAttachmentList.vue';
import { financeEditinfo, financeSubmit, financeReject } from '@/API';
import { mapState } from 'vuex';

export default {
  data () {
    return {
      info: {},
      historyData: [],
      productData: {},
      contractAttachmentListData: [],
      rejectedVisible: false,
      rejectedInfo: ''
    };
  },

  computed: {
    ...mapState({ userInfo: state => state.user })
  },

  methods: {
    submit () {
      let parmas = {
        contractId: this.info.contractId,
        contractNum: this.info.rnewContractNum,
        action: 'submit',
        remarks: '同意'
      };
      financeSubmit(parmas).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.$message.success('提交成功，返回待审批退换货列表');
          this.$router.push({ name: 'finance_thh_list' });
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    back () {
      this.rejectedVisible = true;
    },
    initReject () {
      this.rejectedVisible = false;
      this.rejectedInfo = null;
    },
    submitReject () {
      let parmas = {
        contractId: this.$route.query.contractId,
        remarks: this.rejectedInfo,
        currentUserId: this.userInfo.userId,
        currentUserName: this.userInfo.userName
      };
      financeReject(parmas).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.$router.push({ name: 'finance_thh_list' });
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    baseInfo () {
      let parmas = {
        contractId: this.$route.query.contractId,
        contractType: this.$route.query.contratType
      };
      financeEditinfo(parmas).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.info = json.data.baseInfoModelVO;
          this.historyData = json.data.approveLogList;
          this.productData = json.data.addressMOdelVOS[0].addressList[0];
          this.contractAttachmentListData = json.data.contractAttachmentList;
        }
      }).catch(() => {

      });
    }
  },
  mounted () {
    this.baseInfo();
  },
  components: {
    baseInfo,
    history,
    product,
    contractAttachmentList
  }
};
</script>

<style>

</style>
